import { z } from 'zod'
import { TRAINER_CONTRACT_VERSION } from './trainer-event-read'

/** Storage/upload signed-URL and long-poll contracts stay intentionally loose: handlers keep exact validation order and status branching. */
const storageObject = z.object({
  contract_version: z.literal(TRAINER_CONTRACT_VERSION),
}).passthrough()


export const trainerChannelAttachmentStartResponseSchema = storageObject
export type TrainerChannelAttachmentStartResponse = z.infer<typeof trainerChannelAttachmentStartResponseSchema>

export const trainerChannelAttachmentCompleteResponseSchema = storageObject
export type TrainerChannelAttachmentCompleteResponse = z.infer<typeof trainerChannelAttachmentCompleteResponseSchema>

export const trainerChannelAttachmentSignedDownloadResponseSchema = storageObject
export type TrainerChannelAttachmentSignedDownloadResponse = z.infer<typeof trainerChannelAttachmentSignedDownloadResponseSchema>
